module.exports = __webpack_public_path__ + "img/search-_empt.d9d51fe9.svg";